module.exports = __webpack_public_path__ + "static/media/Vicenza.d61d6fe2.png";